import { defineMessages } from "react-intl";
import classNames from "classnames";

import ButtonLink from "../Buttons/ButtonLink";
import { useFormatMessage } from "../Intl/Context";

const SkipToContentButton = () => {
  const t = useFormatMessage();
  const label = t(intlMessages.label);

  const btnSkipContentClassName = classNames([
    "skip-to-content-button-link",
    "btn",
    "btn-primary"
  ]);

  return (
    <ButtonLink
      // Use a simple `<a>` here to avoid react-router related issues as this link is just
      // an anchor link and is rendered outside of the Router context
      LinkComponent={"a"}
      className={btnSkipContentClassName}
      href="#main"
      label={label}
    />
  );
};

export default SkipToContentButton;

const intlMessages = defineMessages({
  label: {
    id: "header.button.skipToContent",
    defaultMessage: "Aller au contenu principal"
  }
});
